// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-down-tray.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/arrow-down-tray'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowDownTrayIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
